<template>
  <div class="page-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="page-top">
        <div class="time-box">
          <div class="coupon-text">当前优惠券</div>
          <div class="time-cell" v-if="couponInfo.useStatus !== 2">
            <div class="begin-distance">
              {{ couponInfo.title }}
            </div>
            <van-count-down v-if="couponInfo.downTime" :time="couponInfo.downTime" class="count-down">
              <template #default="{ days, hours, minutes, seconds }">
                <span v-if="days">{{ days > 9 ? days : '0' + days }}天</span>
                <span v-if="hours">{{ hours > 9 ? hours : '0' + hours }}:</span>
                <span v-if="minutes">{{ minutes > 9 ? minutes : '0' + minutes }}:</span>
                <span>{{ seconds > 9 ? seconds : '0' + seconds }}</span>
              </template>
            </van-count-down>
          </div>
        </div>
        <div class="coupon-item-wrp" :class="{ 'activity-has-finish': activityHasFinish }">
          <div class="coupon-item" :class="{ 'has-get-bg': isHasReactiveCoupon && couponInfo.useStatus !== 2 }">
            <div class="coupon-item-left">
              <div class="coupon-type">当前页面可用</div>
              <couponPrice
                :price="Number(couponInfo.couponValue)"
                :color="isHasReactiveCoupon ? '#eb6b3f' : activityHasFinish ? '#d8d8d8' : '#fe2c38'"
              />
              <div class="full-amount-des">
                {{ couponInfo.useCondition }}
              </div>
            </div>
            <div class="divider-box"></div>
            <div class="coupon-item-center">
              <div class="coupon-name van-ellipsis">{{ couponInfo.couponName }}</div>
              <div class="coupon-effect-text">
                {{ couponInfo.downTime ? couponInfo.endTime + '到期' : couponInfo.endTime }}
              </div>
            </div>
            <div class="coupon-item-right">
              <!-- <span class="has-finish-text" v-if="activityHasFinish">已结束</span> -->
              <van-button
                class="go-use-btn"
                v-if="!isHasReactiveCoupon && couponInfo.status === 1 && couponInfo.limitNum > couponInfo.hasNum"
                @click.stop="receiveCoupon(couponInfo.activityId)"
                >立即领取</van-button
              >
              <!-- <span class="has-ger-text" v-if="couponInfo.useStatus !== 1">已领取</span> -->
              <span class="has-ger-text" v-if="isHasReactiveCoupon">{{
                couponInfo.useStatus === 2 ? '已使用' : '已领取'
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="goods-box">
        <div class="filter-nav-box">
          <div class="filter-nav">
            <div
              class="filter-nav-item"
              :class="{ active: filterType === item.value }"
              v-for="item in couponGoodsNavItems"
              :key="item.value"
              @click="onClickFilterItem(item.value, item.sort)"
            >
              <div>{{ item.label }}</div>
              <van-icon
                v-if="item.sort"
                :name="item.sort === CouponGoodsListSortEnum.ASCEND ? 'ascending' : 'descending'"
              />
            </div>
          </div>
          <van-icon @click="clickGoodsLayoutIcon" :size="13" :name="isGoodsLayoutList ? ListIcon : GirdIcon" />
        </div>
        <van-list
          class="list-container"
          v-if="couponInfo.couponId"
          v-model:loading="loading"
          :finished="finished"
          :immediate-check="true"
          :finished-text="finishedText"
          @load="getList"
        >
          <div class="goods-list" :style="{ display: isGoodsLayoutList ? 'block' : 'flex' }">
            <div
              class="goods-item"
              :class="{ 'goods-item-col': isGoodsLayoutList }"
              v-for="item in list"
              :key="item.goodsId"
              @click="goGoodsDetails(item.goodsId)"
            >
              <div class="goods-img-box" :class="{ 'goods-cover': isGoodsLayoutList }">
                <van-image :src="item.bannerList[0]" width="100%" height="100%" />
                <van-image
                  class="goods-cover-img"
                  width="100%"
                  height="100%"
                  v-if="item.emptyStockType"
                  :src="getEmptyStockTypeImg(item.emptyStockType)"
                />
              </div>
              <div class="goods-info">
                <div class="goods-name van-ellipsis">{{ item.goodsName }}</div>
                <div class="goods-des van-ellipsis">{{ item.saleDesc }}</div>
                <div class="goods-bottom">
                  <div class="goods-price">
                    <span class="goods-sale-price"
                      >¥<span>{{ item.salePrice }}</span></span
                    >
                    <del>{{ item.marketPrice }}</del>
                  </div>
                  <van-icon :size="20" name="add" />
                </div>
              </div>
            </div>
          </div>
        </van-list>
        <div class="empty-box" v-if="list.length == 0 && !loading">
          <van-empty image-size="240" image="https://i.xurl.cn/x_dsx_wxapp/empty/result.png" description="暂无数据" />
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script setup>
import GirdIcon from '@/assets/img/gird_icon.png'
import ListIcon from '@/assets/img/list_icon.png'
import { getGoodsList } from '@/api/goods'
import { memberCouponReceiveInfo, getCouponActivityInfo, receiveActivityCoupon } from '@/api/coupon'
import { useRoute } from 'vue-router'
import usePage from '@/hooks/usePage'
import { WxPage } from '../../enum'
import { ref, computed, reactive, onMounted } from 'vue'
import couponPrice from './component/couponPrice.vue'

import {
  CouponGoodsFilterItems,
  CouponGoodsFilterEnum,
  CouponGoodsListSortEnum,
  CouponGoodsLayoutTypeEnum
} from './coupon.data'
import { showToast } from 'vant'
const { query } = useRoute()
const { goWxAppPage } = usePage()

const couponInfo = reactive({
  title: '',
  rid: 0,
  couponId: 0,
  downTime: 0,
  endTime: '',
  useCondition: '',
  status: 0,
  useType: '',
  couponValue: '',
  couponName: '',
  limitNum: 0,
  hasNum: 0,
  useStatus: 1
})

const filterType = ref(CouponGoodsFilterEnum.COMPOSITE)
const couponGoodsNavItems = ref([...CouponGoodsFilterItems])

const onClickFilterItem = (value, sort) => {
  if (filterType.value === value && sort) {
    const item = couponGoodsNavItems.value.filter(d => d.value === value)[0]
    item.sort = sort === CouponGoodsListSortEnum.DESC ? CouponGoodsListSortEnum.ASCEND : CouponGoodsListSortEnum.DESC
  } else {
    filterType.value = value
  }
  onloadGoodsList()
}

const goodsLayoutType = ref(CouponGoodsLayoutTypeEnum.GIRD)
const isGoodsLayoutList = computed(() => goodsLayoutType.value === CouponGoodsLayoutTypeEnum.LIST)
const clickGoodsLayoutIcon = () => {
  goodsLayoutType.value =
    goodsLayoutType.value === CouponGoodsLayoutTypeEnum.GIRD
      ? CouponGoodsLayoutTypeEnum.LIST
      : CouponGoodsLayoutTypeEnum.GIRD
}

const pageParams = reactive({
  page: 1,
  pageSize: 20
})
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))

const activityHasFinish = computed(() => !isHasReactiveCoupon.value && [2, 3].includes(couponInfo.status))

const reset = () => {
  finished.value = false
  list.value = []
  pageParams.page = 1
}

const getList = async () => {
  const params = {
    ...pageParams,
    couponId: couponInfo.couponId,
    sortField: filterType.value,
    sortType: couponGoodsNavItems.value.filter(d => filterType.value === d.value)[0].sort
  }
  loading.value = true
  try {
    const resData = await getGoodsList(params)
    list.value.push(...resData.list)
    pageParams.page++
    finished.value = resData.list.length === 0
  } catch {
    finished.value = true
  } finally {
    loading.value = false
  }
}

const onloadGoodsList = () => {
  reset()
  getList()
}

const refreshing = ref(false)
const onRefresh = async () => {
  refreshing.value = true
  try {
    onloadGoodsList()
    getCouponInfo()
  } finally {
    refreshing.value = false
  }
}

const goGoodsDetails = goodsId => {
  goWxAppPage(`${WxPage.goodsDetails}?goodsId=` + goodsId + '&comeType=9')
}

const getEmptyStockTypeImg = emptyType => {
  return `https://x.jzbull.com/x_dsx_wxapp/icov_newPart/${
    {
      1: 'saled2',
      2: 'saled0',
      3: 'saled3',
      4: 'saled4',
      6: 'saled6'
    }[emptyType]
  }.png`
}

const isHasReactiveCoupon = ref(false)
const setCouponInfo = ({
  coupon_id,
  last_time,
  use_condition,
  status,
  end_time,
  use_type,
  coupon_value,
  coupon_name,
  rid,
  activity_id,
  title,
  limit_num,
  has_num,
  useStatus
}) => {
  couponInfo.title = title
  couponInfo.couponId = coupon_id
  couponInfo.downTime = Number(last_time) * 1000
  couponInfo.endTime = end_time
  couponInfo.useCondition = use_condition
  couponInfo.status = status
  couponInfo.useType = use_type
  couponInfo.couponValue = coupon_value
  couponInfo.couponName = coupon_name
  couponInfo.activityId = activity_id
  couponInfo.limitNum = limit_num
  couponInfo.hasNum = has_num
  couponInfo.useStatus = useStatus
  isHasReactiveCoupon.value = Boolean(rid)
}

const receiveCoupon = async activityId => {
  try {
    const res = await receiveActivityCoupon({ activity_id: activityId })
    if (res && !res.code) {
      isHasReactiveCoupon.value = true
      showToast('领券成功')
    } else {
      showToast(res.message)
    }
  } catch {}
}

const getCouponInfo = async () => {
  const activityId = Number(query.activityId || 0)
  const rid = Number(query.rid || 0)
  console.log(rid)
  const { info } = rid
    ? await memberCouponReceiveInfo({ rid: query.rid || 0 })
    : await getCouponActivityInfo({ activity_id: activityId })
  setCouponInfo(info)
}
onMounted(() => {
  loading.value = true
  try {
    getCouponInfo()
  } finally {
    loading.value = false
  }
})
</script>

<style lang="less" scoped>
@primary-color: #fd6f54;
@font-primary-color: #ff6262;
.page-container {
  overflow: auto;
  font-size: 14px;
  padding-bottom: 16px;
  .page-top {
    background-color: #fff;
    padding: 12px;
    border-radius: 4px;
    margin: 12px 0;
    .time-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      .begin-distance {
        margin-left: 8px;
        margin-right: 4px;
      }
      .coupon-text {
        color: #222;
        font-weight: 500;
      }
      .count-down {
        color: @font-primary-color;
      }
      .time-cell {
        display: flex;
      }
    }
    .coupon-item-wrp {
      background-color: #fddac6;
      padding: 4px;
      border-radius: 8px;
      overflow: hidden;
      .coupon-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: white;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        .coupon-item-left {
          text-align: center;
          width: 95px;
          .coupon-type {
            max-width: 90px;
            height: 18px;
            line-height: 18px;
            color: #fff;
            font-size: 10px;
            box-sizing: border-box;
            padding: 0 8px;
            position: absolute;
            top: 0px;
            text-align: left;
            background: linear-gradient(90deg, #ffa086 0%, #fb643e 100%);
            border-radius: 8px 0px 8px 0px;
          }
          .full-amount-des {
            //   margin-top: 4px;
            color: @font-primary-color;
            font-weight: 500;
            // color: var(--van-black-9);
            font-size: 11px;
            font-family: Avenir;
          }
        }
        .divider-box {
          position: relative;
          border-left: dashed #d8d8d8 1px;
          height: 88px;
          padding: 0 8px;
          .red-circle {
            content: '';
            display: block;
            position: absolute;
            width: 10px;
            height: 10px;
            background-color: #fddac6;
            border-radius: 50%;
            left: -6px;
          }
          &::before {
            .red-circle();
            top: -6px;
          }
          &::after {
            .red-circle();
            bottom: -6px;
          }
        }
        .coupon-item-center {
          flex: 1;
          padding: 16px 0;
          .coupon-name {
            font-size: 16px;
            font-weight: 600;
            color: var(--van-black-2);
            max-width: 165px;
          }
          .coupon-effect-text {
            position: relative;
            font-size: 12px;
            color: var(--van-black-6);
            margin: 8px 0;
            font-weight: 400;
          }
          // .use-des {
          //   color: var(--van-black-9);
          //   font-weight: 400;
          //   font-size: 12px;
          //   display: inline-block;
          //   .arrow-down-wrp {
          //     background-color: #f5f8f8;
          //     border-radius: 50%;
          //     display: inline-block;
          //     padding: 2px;
          //     line-height: 0;
          //   }
          // }
        }
        .coupon-item-right {
          padding-right: 12px;
          .btn {
            height: 24px;
            font-size: 12px;
            border: none;
            width: 60px;
            padding: 0;
            border-radius: 14px;
          }
          .go-use-btn {
            width: 68px;
            height: 24px;
            background: linear-gradient(180deg, #fe5f70 0%, #fe3a4a 100%);
            border-radius: 14px;
            padding: 0;
            border: none;
            color: #fff;
            font-size: 12px;
          }
        }
      }
      .has-get-bg {
        background-color: #fef9f6;
        background-image: url(https://x.jzbull.com/x_dsx_wxapp/coupon/coupon-has-logo.png);
        background-size: 58px 58px;
        background-repeat: no-repeat;
        background-position: 105% 40px;
        color: #eb6b3f;
        .coupon-item-left {
          .full-amount-des {
            color: #eb6b3f;
          }
        }
        .divider-box {
          border-left: dashed #d8d8d8 1px;
        }
        .has-ger-text {
          font-size: 16px;
          color: #eb6b3f;
          font-weight: bold;
        }
      }
    }
    .activity-has-finish {
      background-color: #d8d8d8;
      .coupon-item {
        background-color: #fff !important;
        background-image: none;
        .coupon-item-left {
          .coupon-type {
            background: linear-gradient(270deg, #d8d8d8 0%, rgba(216, 216, 216, 0.5) 100%) !important ;
          }
          .full-amount-des {
            color: #d8d8d8 !important ;
          }
        }
        .divider-box {
          .red-circle {
            background-color: #d8d8d8 !important;
          }
          &::before {
            .red-circle();
          }
          &::after {
            .red-circle();
          }
        }
        .coupon-item-center {
          .coupon-name {
            color: #d8d8d8 !important ;
          }
          .coupon-effect-text {
            color: #d8d8d8 !important ;
          }
        }
        .coupon-item-right {
          .has-finish-text {
            color: #d8d8d8 !important ;
            font-size: 16px !important;
            font-weight: bold !important;
          }
        }
      }
    }
  }
  .goods-box {
    .filter-nav-box {
      display: flex;
      background-color: #fff;
      justify-content: space-between;
      align-items: center;
      padding: 12px;
      font-size: 14px;
    }
    .filter-nav {
      display: flex;
      color: var(--van-black-9);
      .filter-nav-item {
        display: flex;
        align-items: center;
        margin-right: 32px;
      }
      .active {
        color: var(--van-black-2);
      }
    }
    .goods-list {
      display: flex;
      flex-wrap: wrap;
      .goods-item {
        margin: 12px;
        margin-right: 0px;
        margin-bottom: 0px;
        background-color: white;
        box-shadow: 0px 1px 10px 0px rgba(157, 165, 212, 0.1);
        border-radius: 8px;
        overflow: hidden;
        .goods-img-box,
        .goods-cover {
          width: 170px;
          height: 170px;
          position: relative;
        }
        .goods-cover-img {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
          background: rgba(0, 0, 0, 0.2);
        }
        .goods-info {
          padding: 10px;
          .goods-name {
            font-weight: 400;
            color: #000000;
            max-width: 150px;
          }
          .goods-des {
            color: var(--van-black-9);
            font-size: 12px;
            margin-top: 6px;
            margin-bottom: 12px;
            max-width: 150px;
          }
          .goods-bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-family: Verdana;
            .goods-sale-price {
              margin-right: 4px;
            }
            del {
              color: var(--van-black-9);
              font-size: 12px;
            }
          }
        }
      }
      .goods-item-col {
        display: flex;
        border-radius: 0;
        margin-right: 12px;
        background-color: inherit;
        box-shadow: inherit;
        .goods-info {
          flex: 1;
        }
        .goods-img-box,
        .goods-cover {
          width: 100px;
          height: 100px;
        }
      }
    }
  }
}
</style>
